import type { FC } from 'react';

import { ImageComponent } from '@/components/Image';
import { PoolLevelEnum } from '@/helpers/jackpot';

import { ScAnimatedCrystal } from './styled';

interface AnimatedCrystalProps {
  type: PoolLevelEnum;
  size?: number;
}

const CRYSTAL_NAMES: Record<PoolLevelEnum, string> = {
  [PoolLevelEnum.PIONEERS]: 'pioneers',
  [PoolLevelEnum.LEGENDS]: 'legends',
  [PoolLevelEnum.TITANS]: 'titans',
};

export const AnimatedCrystal: FC<AnimatedCrystalProps> = ({
  type,
  size = 80,
}) => {
  const name = CRYSTAL_NAMES[type];

  const commonImageProps = {
    width: size,
    height: size,
    alt: `${name} crystal`,
  };

  return (
    <ScAnimatedCrystal>
      <div className="crystal-1">
        <ImageComponent
          src={`/jackpot/levels/${name}1.webp`}
          {...commonImageProps}
        />
      </div>
      <div className="crystal-2">
        <ImageComponent
          src={`/jackpot/levels/${name}2.webp`}
          {...commonImageProps}
        />
      </div>
    </ScAnimatedCrystal>
  );
};
